import { render, staticRenderFns } from "./FieldsetLocalizedInput.vue?vue&type=template&id=8c1fe5b6&scoped=true&"
import script from "./FieldsetLocalizedInput.vue?vue&type=script&lang=js&"
export * from "./FieldsetLocalizedInput.vue?vue&type=script&lang=js&"
import style0 from "./FieldsetLocalizedInput.vue?vue&type=style&index=0&id=8c1fe5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1fe5b6",
  null
  
)

export default component.exports